import { Component, Input, ViewChild, forwardRef, Optional, Inject } from '@angular/core';
import { Router } from '@angular/router';

import { MdSidenav, MdSidenavToggleResult } from '@angular/material';

import { TdLayoutComponent } from '../layout.component';
export class TdLayoutNavListComponent {

   _sideNav: MdSidenav;
/**
 * toolbarTitle?: string
 * 
 * Title set in toolbar.
 */
toolbarTitle: string;
/**
 * icon?: string
 * icon name to be displayed before the title
 */
icon: string;
/**
 * logo?: string
 * 
 * logo icon name to be displayed before the title.
 * If [icon] is set, then this will not be shown.
 */
logo: string;
/**
 * color?: string
 * 
 * toolbar color option: primary | accent | warn.
 * If [color] is not set, primary is used.
 */
color: string = 'primary';
/**
 * mode?: 'side', 'push' or 'over'
 * 
 * The mode or styling of the sidenav.
 * Defaults to "side".
 * See "MdSidenav" documentation for more info.
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 */
mode: 'side' | 'push' | 'over' = 'side';
/**
 * opened?: boolean
 * Whether or not the sidenav is opened. Use this binding to open/close the sidenav.
 * Defaults to "true".
 * 
 * See "MdSidenav" documentation for more info.
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 */
opened: boolean = true;
/**
 * sidenavWidth?: string
 * 
 * Sets the "width" of the sidenav in either "px" or "%" ("%" is not well supported yet as stated in the layout docs)
 * Defaults to "350px".
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 */
sidenavWidth: string = '350px';
/**
 * navigationRoute?: string
 * 
 * option to set the combined route for the icon, logo, and toolbarTitle.
 */
navigationRoute: string;
/**
 * Checks if there is a [TdLayoutComponent] as parent.
 * @return {?}
 */
get isMainSidenavAvailable(): boolean {
    return !!this._layout;
  }
/**
 * Checks if `ESC` should close the sidenav
 * Should only close it for `push` and `over` modes
 * @return {?}
 */
get disableClose(): boolean {
    return this.mode === 'side';
  }
/**
 * Checks if router was injected.
 * @return {?}
 */
get routerEnabled(): boolean {
    return !!this._router && !!this.navigationRoute;
  }
/**
 * @param {?} _layout
 * @param {?} _router
 */
constructor(
private _layout: TdLayoutComponent,
private _router: Router) {}
/**
 * @return {?}
 */
handleNavigationClick(): void {
    if (this.routerEnabled) {
      this._router.navigateByUrl(this.navigationRoute);
    }
  }
/**
 * Proxy toggle method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public toggle(): Promise<MdSidenavToggleResult> {
    return this._sideNav.toggle();
  }
/**
 * Proxy open method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public open(): Promise<MdSidenavToggleResult> {
    return this._sideNav.open();
  }
/**
 * Proxy close method to access sidenav from outside (from td-layout template).
 * @return {?}
 */
public close(): Promise<MdSidenavToggleResult> {
    return this._sideNav.close();
  }
/**
 * If main sidenav is available, it will open the sidenav of the parent [TdLayoutComponent].
 * @return {?}
 */
openMainSidenav(): void {
    this._layout.open();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  selector: 'td-layout-nav-list',
  styleUrls: ['./layout-nav-list.component.css' ],
  templateUrl: './layout-nav-list.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: TdLayoutComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => TdLayoutComponent), ] }, ]},
{type: Router, decorators: [{ type: Optional }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'_sideNav': [{ type: ViewChild, args: [MdSidenav, ] },],
'toolbarTitle': [{ type: Input, args: ['toolbarTitle', ] },],
'icon': [{ type: Input, args: ['icon', ] },],
'logo': [{ type: Input, args: ['logo', ] },],
'color': [{ type: Input, args: ['color', ] },],
'mode': [{ type: Input, args: ['mode', ] },],
'opened': [{ type: Input, args: ['opened', ] },],
'sidenavWidth': [{ type: Input, args: ['sidenavWidth', ] },],
'navigationRoute': [{ type: Input, args: ['navigationRoute', ] },],
};
}

function TdLayoutNavListComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdLayoutNavListComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdLayoutNavListComponent.ctorParameters;
/** @type {?} */
TdLayoutNavListComponent.propDecorators;
/** @type {?} */
TdLayoutNavListComponent.prototype._sideNav;
/**
 * toolbarTitle?: string
 * 
 * Title set in toolbar.
 * @type {?}
 */
TdLayoutNavListComponent.prototype.toolbarTitle;
/**
 * icon?: string
 * icon name to be displayed before the title
 * @type {?}
 */
TdLayoutNavListComponent.prototype.icon;
/**
 * logo?: string
 * 
 * logo icon name to be displayed before the title.
 * If [icon] is set, then this will not be shown.
 * @type {?}
 */
TdLayoutNavListComponent.prototype.logo;
/**
 * color?: string
 * 
 * toolbar color option: primary | accent | warn.
 * If [color] is not set, primary is used.
 * @type {?}
 */
TdLayoutNavListComponent.prototype.color;
/**
 * mode?: 'side', 'push' or 'over'
 * 
 * The mode or styling of the sidenav.
 * Defaults to "side".
 * See "MdSidenav" documentation for more info.
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 * @type {?}
 */
TdLayoutNavListComponent.prototype.mode;
/**
 * opened?: boolean
 * Whether or not the sidenav is opened. Use this binding to open/close the sidenav.
 * Defaults to "true".
 * 
 * See "MdSidenav" documentation for more info.
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 * @type {?}
 */
TdLayoutNavListComponent.prototype.opened;
/**
 * sidenavWidth?: string
 * 
 * Sets the "width" of the sidenav in either "px" or "%" ("%" is not well supported yet as stated in the layout docs)
 * Defaults to "350px".
 * 
 * https://github.com/angular/material2/tree/master/src/lib/sidenav
 * @type {?}
 */
TdLayoutNavListComponent.prototype.sidenavWidth;
/**
 * navigationRoute?: string
 * 
 * option to set the combined route for the icon, logo, and toolbarTitle.
 * @type {?}
 */
TdLayoutNavListComponent.prototype.navigationRoute;
/** @type {?} */
TdLayoutNavListComponent.prototype._layout;
/** @type {?} */
TdLayoutNavListComponent.prototype._router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
